import {Button, DialogActions, DialogContent} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import {cancelGenelcoUploadQueue} from 'Enrollment/ducks/enrollmentFileProcessing';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';

type SimplifiedEnrollmentFileUploadCancelConfirmationModalProps = {
  fileId: string;
  onClose: () => void;
};

const SimplifiedEnrollmentFileUploadCancelConfirmationModal = (
  props: SimplifiedEnrollmentFileUploadCancelConfirmationModalProps
) => {
  const {onClose} = props;
  const dispatch = useDispatch();
  const {enrollmentApplicationsFilters} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
  const fileStatusId = EnrollmentFileStatusType.CANCELED;

  const handleRemoveEnrollmentApplication = () => {
    dispatch(cancelGenelcoUploadQueue(props.fileId, fileStatusId, enrollmentApplicationsFilters, undefined));
    onClose();
  };

  return (
    <Modal title="Cancel Confirmation" open onClose={onClose}>
      <div className="card__dialog">
        <DialogContent>Are you sure you would like to cancel this file upload?</DialogContent>
        <DialogActions>
          <Button
            className="modal__footer-enrollment-file-rejects-actions"
            color="primary"
            variant="contained"
            onClick={handleRemoveEnrollmentApplication}
          >
            Cancel
          </Button>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default SimplifiedEnrollmentFileUploadCancelConfirmationModal;
